import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import Lightbox from 'react-images'
import { Button } from 'reactstrap'
import { timesheet_images, timesheet_pdf } from '../../../static/images/manual'

export default class Manual extends React.Component {
  state={ currentImage: 0 }
  handleClickImage = () => {
    if (this.state.currentImage === timesheet_images.length - 1) return
    this.gotoNext()
  }
  gotoImage = (index) => {
    this.setState({ currentImage: index })
  }
  gotoNext = () => {
    this.setState({ currentImage: this.state.currentImage + 1 })
  }
  gotoPrevious = () => {
    this.setState({ currentImage: this.state.currentImage - 1 })
  }
  closeImage = () => {
    this.setState({
      currentImage: 0,
      isOpen: false,
    })
    this.props.closeManual()
  }
  render() {
    const downloadPDF = (
      <CustomButton
        onClick={ () => window.open(timesheet_pdf) }
      >Download
      </CustomButton>)
    return (
      <Lightbox
        images={ timesheet_images }
        backdropClosesModal={ true }
        enableKeyboardInput={ true }
        showThumbnails={ true }
        currentImage={ this.state.currentImage }
        isOpen={ get(this.props, 'isOpen', false) }
        onClickPrev={ this.gotoPrevious }
        onClickNext={ this.gotoNext }
        onClickImage={ this.handleClickImage }
        onClickThumbnail={ this.gotoImage }
        onClose={ this.closeImage }
        customControls={ [downloadPDF] }
      />
    )
  }
}

Manual.propTypes = {
  closeManual: PropTypes.func,
}
Manual.defaultProps = {
  closeManual: () => {},
}

const CustomButton = styled(Button)`
  width: 100px;
  height: 30px;
  font-size: 12px;
  font-family: Gotham;
  color: white;
  background-color: #428BCA;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/helpers/manual.js